/* eslint-disable eqeqeq */
import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import consultaApi from "../../../services/consultaApi";
import Swal from "sweetalert2";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import dbToBoolean from "../../../tools/dbToBoolean";
import { useHistory } from "react-router-dom";
import BuscaForm from "../../gww-lib/busca-no-form/index";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  controlaTitulo: {
    paddingTop: 30,
    paddingBottom: 12,
    fontSize: "2em",
  },
  corDoFundo: {
    backgroundColor: "#f1f1f1",
    paddingBottom: 30,
  },
  containerPrimeiroAcesso: {
    padding: "0px 0px 30px 0px",
  },
  controlaCard: {
    textAlign: "center",
    padding: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  botaoRodape: {
    padding: theme.spacing(1),
  },
}));

function FormConfiguracao(props, ref) {
  const { primeiroAcesso } = props;
  const classes = useStyles();

  const [apresentaVolume, setApresentaVolume] = useState();
  const [apresentaParcela, setApresentaParcela] = useState();
  const [apresentaTransporte, setApresentaTransporte] = useState();
  const [apresentaMensagem, setApresentaMensagem] = useState();
  const [apresentaDescricaoDetalhada, setApresentaDescricaoDetalhada] =
    useState();

  const [cfop, setCfop] = useState("");
  const [descricaoCfop, setDescricaoCfop] = useState("");
  const [cfopErro] = useState(false);
  const [cfopErroTexto] = useState();

  const [unidade, setUnidade] = useState("");
  const [descricaoUnidade, setDescricaoUnidade] = useState("");
  const [unidadeErro] = useState(false);
  const [unidadeErroTexto] = useState();

  const [grupoImposto, setGrupoImposto] = useState("");
  const [descricaoGrupoImposto, setDescricaoGrupoImposto] = useState("");
  const [grupoImpostoErro] = useState(false);
  const [grupoImpostoErroTexto] = useState();

  const history = useHistory();

  useEffect(() => {
    async function buscarDados() {
      let procedure = {
        PROCNAME: "WEBSITE_BUSCA_CONF",
      };

      const resposta = await consultaApi(procedure);

      setApresentaParcela(
        dbToBoolean(resposta.data.DATASET[0].LAPRESENTAPARCELA)
      );
      setApresentaVolume(
        dbToBoolean(resposta.data.DATASET[0].LAPRESENTAVOLUME)
      );
      setApresentaTransporte(
        dbToBoolean(resposta.data.DATASET[0].LAPRESENTATRANSPORTE)
      );
      setApresentaMensagem(
        dbToBoolean(resposta.data.DATASET[0].LAPRESENTAMENSAGEM)
      );
      setApresentaDescricaoDetalhada(
        dbToBoolean(resposta.data.DATASET[0].LAPRESENTACDETPMS)
      );
      setCfop(resposta.data.DATASET[0].CFOPPADRAO);
      setDescricaoCfop(resposta.data.DATASET[0].CDSCFOP);
      setUnidade(resposta.data.DATASET[0].UNIDADEPADRAO);
      setDescricaoUnidade(resposta.data.DATASET[0].CDSUNID);
      setGrupoImposto(resposta.data.DATASET[0].GRUPOIMPOSTOPADRAO);
      setDescricaoGrupoImposto(resposta.data.DATASET[0].CDSTAXGRUPO);
    }
    buscarDados();
  }, []);

  useImperativeHandle(ref, () => ({
    async salvarConfiguracoes() {
      let retornoSalvar = await salvar();
      return retornoSalvar;
    },
  }));

  async function salvar(e) {
    if (e) {
      e.preventDefault();
    }

    let dadosEnvio = {
      PROCNAME: "WEBSITE_CONF_APP_ADD",
      APRESENTAVOLUME: apresentaVolume ? 1 : 0,
      APRESENTAPARCELA: apresentaParcela ? 1 : 0,
      APRESENTACDETPMS: apresentaDescricaoDetalhada ? 1 : 0,
      CFOP: cfop,
      UNIDADE: unidade.toUpperCase(),
      GRUPO_IMPOSTO: grupoImposto,
      APRESENTATRANSPORTE: apresentaTransporte ? 1 : 0,
      APRESENTAMENSAGEM: apresentaMensagem ? 1 : 0,
    };

    const resposta = await consultaApi(dadosEnvio);

    if (resposta.data.CODIGO_ERRO == 0) {
      localStorage.setItem("APRESENTA_VOLUME", apresentaVolume ? 1 : 0);
      localStorage.setItem("APRESENTA_PARCELA", apresentaParcela ? 1 : 0);
      localStorage.setItem("APRESENTA_TRANSPORTE", apresentaTransporte ? 1 : 0);
      localStorage.setItem("APRESENTA_MENSAGEM", apresentaMensagem ? 1 : 0);
      localStorage.setItem(
        "APRESENTA_DESCRICAO_DETALHADA",
        apresentaDescricaoDetalhada ? 1 : 0
      );
      localStorage.setItem("CFOP_PADRAO", cfop);
      localStorage.setItem("DESCRICAO_CFOP_PADRAO", descricaoCfop);
      localStorage.setItem("UNIDADE_PADRAO", unidade);
      localStorage.setItem("DESCRICAO_UNIDADE_PADRAO", descricaoUnidade);
      localStorage.setItem("GRUPO_IMPOSTO_PADRAO", grupoImposto);
      localStorage.setItem(
        "DESCRICAO_GRUPO_IMPOSTO_PADRAO",
        descricaoGrupoImposto
      );

      if (primeiroAcesso) {
        return true;
      } else {
        Swal.fire({
          type: "success",
          title: "Salvo !",
        });
        vaiHome();
      }
    }
  }

  function vaiHome() {
    history.push("/home");
  }

  function cancelar() {
    Swal.fire({
      type: "question",
      title: "Cancelar ?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      showLoaderOnConfirm: true,
      preConfirm: (result) => {
        if (result) {
          vaiHome();
        }
      },
    });
  }

  return (
    <Container
      className={
        primeiroAcesso ? classes.containerPrimeiroAcesso : classes.corDoFundo
      }
    >
      {!primeiroAcesso && (
        <Typography
          variant="h1"
          component="h1"
          gutterBottom
          align="center"
          color="primary"
          className={classes.controlaTitulo}
        >
          Configurações
        </Typography>
      )}

      <Paper className={classes.controlaCard}>
        <form>
          {apresentaVolume != undefined &&
          apresentaParcela != undefined &&
          apresentaTransporte != undefined &&
          apresentaDescricaoDetalhada != undefined &&
          apresentaMensagem != undefined ? (
            <>
              <FormControlLabel
                className={classes.formControl}
                control={
                  <Checkbox
                    checked={apresentaVolume}
                    onChange={(e) => setApresentaVolume(e.target.checked)}
                    name="checkedB"
                    w
                    color="primary"
                  />
                }
                label="Apresenta Volume NF-e"
              />

              <FormControlLabel
                className={classes.formControl}
                control={
                  <Checkbox
                    checked={apresentaParcela}
                    onChange={(e) => setApresentaParcela(e.target.checked)}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="Apresenta Parcela NF-e"
              />

              <FormControlLabel
                className={classes.formControl}
                control={
                  <Checkbox
                    checked={apresentaTransporte}
                    onChange={(e) => setApresentaTransporte(e.target.checked)}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="Apresenta Transporte NF-e"
              />

              <FormControlLabel
                className={classes.formControl}
                control={
                  <Checkbox
                    checked={apresentaMensagem}
                    onChange={(e) => setApresentaMensagem(e.target.checked)}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="Apresenta Mensagem NF-e"
              />

              <FormControlLabel
                className={classes.formControl}
                control={
                  <Checkbox
                    checked={apresentaDescricaoDetalhada}
                    onChange={(e) =>
                      setApresentaDescricaoDetalhada(e.target.checked)
                    }
                    name="checkedB"
                    color="primary"
                  />
                }
                label="Apresenta Descrição Detalhada"
              />

              <BuscaForm
                codigo={cfop}
                tabela="CFOP"
                label="CFOP"
                erroTexto={cfopErroTexto}
                erro={cfopErro}
                setCodigoPai={(cfop) => setCfop(cfop)}
                descricao={descricaoCfop}
                setDescricao={setDescricaoCfop}
                procedureConsulta="WEBSITE_LISTAGEM_TCFOP"
              />

              <BuscaForm
                codigo={unidade}
                tabela="UNIDADE"
                label="Unidade de Medida"
                consultaInstantanea
                setCodigoPai={(unidade) => setUnidade(unidade)}
                setDescricao={setDescricaoUnidade}
                descricao={descricaoUnidade}
                procedureConsulta="WEBSITE_LISTAGEM_UNID"
                erroTexto={unidadeErroTexto}
                erro={unidadeErro}
                tipo="text"
              />

              <BuscaForm
                codigo={grupoImposto}
                tabela="GRUPO_IMPOSTO"
                filtro="CDSTAXGRUPO"
                label="Grupo de Imposto"
                consultaInstantanea
                erroTexto={grupoImpostoErroTexto}
                erro={grupoImpostoErro}
                setCodigoPai={(grupoImposto) => setGrupoImposto(grupoImposto)}
                descricao={descricaoGrupoImposto}
                setDescricao={setDescricaoGrupoImposto}
                procedureConsulta="WEBSITE_LISTAGEM_IMP_GRUPO"
              />
            </>
          ) : (
            <CircularProgress />
          )}
          {!primeiroAcesso && (
            <Grid container>
              <Grid item xs={6} className={classes.botaoRodape}>
                <Button
                  variant="contained"
                  color="secondary"
                  type="button"
                  onClick={cancelar}
                  fullWidth
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item xs={6} className={classes.botaoRodape}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={salvar}
                  fullWidth
                >
                  Salvar
                </Button>
              </Grid>
            </Grid>
          )}
        </form>
      </Paper>
    </Container>
  );
}

export default forwardRef(FormConfiguracao);
